import React, { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';

import clsx from 'clsx';

import './Link.css';
import '../button/Button.css';

type LinkPropsWithoutIcon = {
	icon?: never;
	iconSide?: never;
};

type LinkPropsWithIcon = {
	icon: React.ReactNode;
	iconSide: 'left' | 'right';
};

type LinkPrimitiveProps = {
	acceptanceTestTargetId?: string;
	branded?: boolean;
	disabled?: boolean;
	href?: string;
	className?: string;
	children?: any;
	openInNewTab?: boolean;
	inheritFontSize?: boolean;
	asButton?: boolean;
} & (LinkPropsWithIcon | LinkPropsWithoutIcon);

export type LinkProps = LinkPrimitiveProps &
	DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

function Link({
	acceptanceTestTargetId,
	branded,
	children,
	disabled = false,
	href,
	className,
	openInNewTab,
	icon,
	iconSide,
	asButton,
	inheritFontSize,
	onClick,
	...rest
}: LinkProps) {
	const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		if (!href || href === '/' || disabled) {
			event.stopPropagation();
			event.preventDefault();
		}
		if (onClick && !disabled) {
			onClick(event);
		}
	};

	let restProps = { ...rest };

	if (openInNewTab) {
		restProps = { ...rest, target: '_blank', rel: 'noopener noreferrer' };
	}
	const mainClassName = asButton ? 'button button--primary link-button' : 'link';
	return (
		<a
			{...restProps}
			aria-disabled={disabled}
			className={clsx(
				mainClassName,
				branded && 'branded',
				disabled && 'disabled',
				inheritFontSize && 'inheritFontSize',
				className
			)}
			href={disabled ? undefined : href}
			onClick={handleClick}
		>
			{icon && iconSide === 'left' && <>{icon}</>}
			{children}
			{icon && iconSide === 'right' && <>{icon}</>}
		</a>
	);
}

export default Link;
